'use client';

import Phone from '@/assets/icons/cart/call.svg';
import ArrowLeft from '@/assets/icons/icon-arrow-left.svg';
import Logo from '@/assets/icons/radius_qora_logo.svg';
import Ad from '@/components/shared/ad';
import CardComponent from '@/components/shared/card';
import CardTotal from '@/components/shared/cardTotal';
import PlacingOrder from '@/components/shared/placingOrder';
import ProductAccardion from '@/components/shared/productAccardion';
import { useUserDraftOrdersQuery } from '@/graphql';
import convertToReadable from '@/helpers/convertToReadable';
import useUserStore from '@/zustand/useUser';
import { useState } from 'react';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import { useWindowSize } from 'react-use';
import { Modal, SelectPicker, Text } from 'rsuite';
import styles from './styles.module.scss';
import { CustomCitiesSelect } from '@/components';

type Props = {
  open: any;
  handleClose: () => void;
};

const option = [
  'Eugenia',
  'Bryan',
  'Linda',
  'Nancy',
  'Lloyd',
  'Alice',
  'Julia',
  'Albert',
].map(item => ({ label: item, value: item }));

export default function ShoppingCartModal({ open, handleClose }: Props) {
  const [showAd, setShowAd] = useState(true);
  const { width } = useWindowSize();
  const userData = useUserStore((user: any) => user?.user);
  const isLoggedIn = userData?.id;
  const { data: draftOrdersData } = useUserDraftOrdersQuery({
    variables: {
      userId: userData?.id,
    },
  });

  return (
    <Modal size={'full'} open={open} onClose={handleClose}>
      <div className={styles.container}>
        <header className={styles.headerTop}>
          <div className={styles.headerTopBox}>
            <div className={styles.headerTopWraper}>
              <MdOutlineKeyboardBackspace
                onClick={handleClose}
                className={styles.headerTopIcon}
              />
              <h6 className={styles.headerTopText}>Вернуться к покупкам</h6>
            </div>

            <div className={styles.headerLogo}>
              <Logo />
            </div>
            <div className={styles.rightFlex}>
              <SelectPicker
                data={option}
                searchable={false}
                style={{ width: 150 }}
                placeholder=""
                className={`${styles.select} customSelect`}
              />
              <p className={styles.phoneNumber}>
                {width <= 580 ? (
                  <Phone className={styles.phoneNumberIcon} />
                ) : (
                  '+998 (71) 200 31 00'
                )}
              </p>
            </div>
          </div>
        </header>

        <div className={`${styles.root} container`}>
          <div>
            <div className={styles.headerContainer}>
              <div className={styles.leftFlex}>
                <button className={styles.backButton}>
                  <ArrowLeft className={styles.backButtonIcon} />
                </button>
                <header className={styles.header}>
                  Корзина{' '}
                  <span>{draftOrdersData?.userDraftOrders?.length} товара</span>
                </header>
              </div>

              <div className={styles.rightFlex}>
                <p className={styles.phoneNumber}>
                  {width <= 580 ? (
                    <Phone className={styles.phoneNumberIcon} />
                  ) : (
                    ''
                  )}
                </p>
              </div>
            </div>

            <div className={styles.mobileCity}>
              <div className={styles.mobileCityLeft}>
                <Text className={styles.mobileCityText}>Ваш город:</Text>
                {/* <SelectPicker
                  data={option}
                  searchable={false}
                  style={{ width: 100 }}
                  placeholder=""
                  className={`${styles.customSelect} customSelect`}
                /> */}
                <CustomCitiesSelect />
              </div>
              <button className={styles.nextButton}>
                <ArrowLeft className={styles.nextButtonIcon} />
              </button>
            </div>

            <div className={styles.cardsection}>
              <div className={styles.cardWrapper}>
                {showAd && (
                  <div className={styles.adsection}>
                    <Ad setShowAd={setShowAd} />
                  </div>
                )}
                {draftOrdersData?.userDraftOrders?.map(order => (
                  <CardComponent
                    key={order?.id}
                    userData={userData}
                    data={order?.lines?.[0]}
                  />
                ))}
                <div className={styles.cardFooter}>
                  <Text className={styles.cardFooterText}>
                    Цена за комплект
                  </Text>
                  <Text className={styles.cardTotalPrice}>
                    {convertToReadable(8000000)} сум
                  </Text>
                </div>
                <div>
                  <ProductAccardion />
                </div>
                <div className={styles.mobileCardTotal}>
                  <CardTotal />
                </div>
                {isLoggedIn && (
                  <div style={{ marginTop: '12px' }}>
                    <PlacingOrder />
                  </div>
                )}
              </div>

              <div className={styles.desctopCardTotal}>
                <CardTotal handleClose={handleClose} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
